// Campaign Monitor API Configuration
// Connects to kv_backend for Nota campaign management

const CAMPAIGN_API_CONFIG = {
  DEV: {
    BASE_URL: "http://localhost:5001/api/nota/campaign",
  },
  PROD: {
    BASE_URL: "https://karvon.shop/api/nota/campaign",
  },
};

const CURRENT_ENV = "PROD";

export const CAMPAIGN_BASE_URL = CAMPAIGN_API_CONFIG[CURRENT_ENV].BASE_URL;

export const CAMPAIGN_ENDPOINTS = {
  STATS: `${CAMPAIGN_BASE_URL}/stats`,
  START: `${CAMPAIGN_BASE_URL}/start`,
  STOP: `${CAMPAIGN_BASE_URL}/stop`,
  RETRY_FAILED: `${CAMPAIGN_BASE_URL}/retry-failed`,
  SETTINGS: `${CAMPAIGN_BASE_URL}/settings`,
  UPLOAD_CSV: `${CAMPAIGN_BASE_URL}/upload-csv`,
  CLEAR_QUEUE: `${CAMPAIGN_BASE_URL}/clear-queue`,
  TEST_SEND: `${CAMPAIGN_BASE_URL}/test-send`,
  ACTIVITY: `${CAMPAIGN_BASE_URL}/activity`,
  EXPORT: `${CAMPAIGN_BASE_URL}/export`,
};

const JSON_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response
      .json()
      .catch(() => ({ message: "Unknown error" }));
    throw new Error(
      errorData.message || `HTTP error! status: ${response.status}`,
    );
  }
  return response.json();
};

export const campaignService = {
  getStats: async () => {
    const response = await fetch(CAMPAIGN_ENDPOINTS.STATS, {
      headers: JSON_HEADERS,
    });
    return handleResponse(response);
  },

  start: async () => {
    const response = await fetch(CAMPAIGN_ENDPOINTS.START, {
      method: "POST",
      headers: JSON_HEADERS,
    });
    return handleResponse(response);
  },

  stop: async () => {
    const response = await fetch(CAMPAIGN_ENDPOINTS.STOP, {
      method: "POST",
      headers: JSON_HEADERS,
    });
    return handleResponse(response);
  },

  retryFailed: async () => {
    const response = await fetch(CAMPAIGN_ENDPOINTS.RETRY_FAILED, {
      method: "POST",
      headers: JSON_HEADERS,
    });
    return handleResponse(response);
  },

  getSettings: async () => {
    const response = await fetch(CAMPAIGN_ENDPOINTS.SETTINGS, {
      headers: JSON_HEADERS,
    });
    return handleResponse(response);
  },

  updateSettings: async (settings) => {
    const response = await fetch(CAMPAIGN_ENDPOINTS.SETTINGS, {
      method: "PUT",
      headers: JSON_HEADERS,
      body: JSON.stringify(settings),
    });
    return handleResponse(response);
  },

  uploadCsv: async (file, preview = false) => {
    const formData = new FormData();
    formData.append("csv", file);
    const url = preview
      ? `${CAMPAIGN_ENDPOINTS.UPLOAD_CSV}?preview=true`
      : CAMPAIGN_ENDPOINTS.UPLOAD_CSV;
    const response = await fetch(url, { method: "POST", body: formData });
    return handleResponse(response);
  },

  clearQueue: async () => {
    const response = await fetch(CAMPAIGN_ENDPOINTS.CLEAR_QUEUE, {
      method: "POST",
      headers: JSON_HEADERS,
    });
    return handleResponse(response);
  },

  testSend: async (email) => {
    const response = await fetch(CAMPAIGN_ENDPOINTS.TEST_SEND, {
      method: "POST",
      headers: JSON_HEADERS,
      body: JSON.stringify({ email }),
    });
    return handleResponse(response);
  },

  getActivity: async (limit = 20) => {
    const response = await fetch(
      `${CAMPAIGN_ENDPOINTS.ACTIVITY}?limit=${limit}`,
      { headers: JSON_HEADERS },
    );
    return handleResponse(response);
  },

  getExportUrl: () => CAMPAIGN_ENDPOINTS.EXPORT,
};

export default campaignService;
